<section class="search-result p-3">
  <div class="num">
    <p class="m-0">نتیجه جستجو: 3</p>
  </div>
  <div class="item d-flex align-items-start py-3">
    <div class="ms-3">
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.735 6.1875H3.26496C2.70441 6.1875 2.25 6.64191 2.25 7.20246V14.1725C2.25 14.7331 2.70441 15.1875 3.26496 15.1875H14.735C15.2956 15.1875 15.75 14.7331 15.75 14.1725V7.20246C15.75 6.64191 15.2956 6.1875 14.735 6.1875Z"
          stroke="#4D4D4D"
          stroke-linejoin="round"
        />
        <path
          d="M5.0625 2.8125H12.9375"
          stroke="#4D4D4D"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
        <path
          d="M3.9375 4.5H14.0625"
          stroke="#4D4D4D"
          stroke-miterlimit="10"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <div>
      <h6 class="m-0">
        گروه داشبوری یک
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 6.5H9.625L8 1.5L6.375 6.5H1L5.375 9.5L3.6875 14.5L8 11.375L12.3125 14.5L10.625 9.5L15 6.5Z"
            stroke="#959595"
            stroke-linejoin="round"
          />
        </svg>
      </h6>
      <p class="m-0">
        <span>ایجادکننده</span>
        رضا رضایی
      </p>
      <p class="m-0">
        <span>بازدید</span>
        3 نفر
      </p>
    </div>
  </div>

  <div class="item d-flex align-items-start py-3">
    <div class="ms-3">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.625 15.75H3.375C3.07689 15.7492 2.79122 15.6304 2.58043 15.4196C2.36963 15.2088 2.25083 14.9231 2.25 14.625V3.375C2.25083 3.07689 2.36963 2.79122 2.58043 2.58043C2.79122 2.36963 3.07689 2.25083 3.375 2.25H14.625C14.9231 2.25083 15.2088 2.36963 15.4196 2.58043C15.6304 2.79122 15.7492 3.07689 15.75 3.375V14.625C15.7492 14.9231 15.6304 15.2088 15.4196 15.4196C15.2088 15.6304 14.9231 15.7492 14.625 15.75Z" stroke="#4D4D4D" stroke-linecap="round" stroke-linejoin="round"/>
            <g clip-path="url(#clip0)">
            <path d="M10.9336 9.52734L12.8672 7.59375" stroke="#4D4D4D" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8.47266 8.12109L9.87891 9.52734" stroke="#4D4D4D" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.13281 10.4062L7.41797 8.12109" stroke="#4D4D4D" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.3945 7.59375C13.6858 7.59375 13.9219 7.35765 13.9219 7.06641C13.9219 6.77516 13.6858 6.53906 13.3945 6.53906C13.1033 6.53906 12.8672 6.77516 12.8672 7.06641C12.8672 7.35765 13.1033 7.59375 13.3945 7.59375Z" fill="#4D4D4D" stroke="#4D4D4D" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.4062 10.582C10.6975 10.582 10.9336 10.3459 10.9336 10.0547C10.9336 9.76344 10.6975 9.52734 10.4062 9.52734C10.115 9.52734 9.87891 9.76344 9.87891 10.0547C9.87891 10.3459 10.115 10.582 10.4062 10.582Z" fill="#4D4D4D" stroke="#4D4D4D" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.94531 8.12109C8.23656 8.12109 8.47266 7.88499 8.47266 7.59375C8.47266 7.30251 8.23656 7.06641 7.94531 7.06641C7.65407 7.06641 7.41797 7.30251 7.41797 7.59375C7.41797 7.88499 7.65407 8.12109 7.94531 8.12109Z" fill="#4D4D4D" stroke="#4D4D4D" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.60547 11.4609C4.89671 11.4609 5.13281 11.2248 5.13281 10.9336C5.13281 10.6423 4.89671 10.4062 4.60547 10.4062C4.31422 10.4062 4.07812 10.6423 4.07812 10.9336C4.07812 11.2248 4.31422 11.4609 4.60547 11.4609Z" fill="#4D4D4D" stroke="#4D4D4D" stroke-width="0.7" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
            <clipPath id="clip0">
            <rect width="11.25" height="11.25" fill="white" transform="translate(3.375 3.375)"/>
            </clipPath>
            </defs>
            </svg>
            
    </div>
    <div>
      <h6 class="m-0">
        گزارش دوم
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 6.5H9.625L8 1.5L6.375 6.5H1L5.375 9.5L3.6875 14.5L8 11.375L12.3125 14.5L10.625 9.5L15 6.5Z"
            stroke="#959595"
            stroke-linejoin="round"
          />
        </svg>
      </h6>
      <p class="m-0">
        <span>ایجادکننده</span>
        رضا رضایی
      </p>
      <p class="m-0">
        <span>بازدید</span>
        3 نفر
      </p>
    </div>
  </div>

  <div class="item d-flex align-items-start py-3">
    <div class="ms-3">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 8.125C14.1421 8.125 17.5 6.72589 17.5 5C17.5 3.27411 14.1421 1.875 10 1.875C5.85786 1.875 2.5 3.27411 2.5 5C2.5 6.72589 5.85786 8.125 10 8.125Z" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M17.5 8.35938C17.5 10.0852 14.1406 11.4844 10 11.4844C5.85938 11.4844 2.5 10.0852 2.5 8.35938" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M17.5 11.7188C17.5 13.4445 14.1406 14.8438 10 14.8438C5.85938 14.8438 2.5 13.4445 2.5 11.7188" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M2.5 4.96973V15.0291C2.5 16.7385 5.85938 18.1244 10 18.1244C14.1406 18.1244 17.5 16.7385 17.5 15.0291V4.96973" stroke="#4D4D4D" stroke-miterlimit="10" stroke-linecap="round"/>
            </svg>
            
    </div>
    <div>
      <h6 class="m-0">
        منبع سه
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 6.5H9.625L8 1.5L6.375 6.5H1L5.375 9.5L3.6875 14.5L8 11.375L12.3125 14.5L10.625 9.5L15 6.5Z"
            stroke="#959595"
            stroke-linejoin="round"
          />
        </svg>
      </h6>
      <p class="m-0">
        <span>ایجادکننده</span>
        رضا رضایی
      </p>
      <p class="m-0">
        <span>بازدید</span>
        3 نفر
      </p>
    </div>
  </div>
</section>
